import { shuffle } from '../helpers/functions.js'
import { alphabetical } from '../helpers/functions.js'

export const MainModule = {
  state: {
    schools: [], //remains 99% static, order is shuffled on reset
    filteredSchools: {
      normal: [],
      choice: [],
      results: 0
    },
    homeschools: [],
    showMobileFilters: false,
    compare: {
      active: false,
      schools: {}, // maybe change to array in future?
      categories: [],
      keys: [],
    },
    tooltip: {
      display: false,
      id: 0,
      title: '',
      description: ''
    },
    moreModal: {
      school: {},
      active: false,
      returnElement: {}
    },
    language: {
      previous: '',
      current: ''
    },
    translateBar: {
      active: false
    },
    translateDropdown: {
      active: false
    },
    loading: {
      active: false
    },
    timeout: {
      active: false
    }
  },
  getters: {
    // this is for select menu on enrollment page
    categorizedSchools(state) {
      const obj = { preschool: [], elementary: [], junior_high: [], high_school: [], choice: [] }
      state.schools.forEach(s => {
        if (s.types.includes("choice")) {
          obj.choice.push(s)
        }
        if (s.types.includes("elementary")) {
          obj.elementary.push(s)
        }
        if (s.types.includes("jr_high")) {
          obj.junior_high.push(s)
        }
        if (s.types.includes("high_school")) {
          obj.high_school.push(s)
        }
        if (s.types.includes("preschool")) {
          obj.preschool.push(s)
        }
      })
      obj.preschool.sort((a,b) => alphabetical(a,b))
      obj.elementary.sort((a,b) => alphabetical(a,b))
      obj.junior_high.sort((a,b) => alphabetical(a,b))
      obj.high_school.sort((a,b) => alphabetical(a,b))
      obj.choice.sort((a,b) => alphabetical(a,b))
      return obj
    },
    modalOpen(state) {
      return state.moreModal.active || state.compare.active
    }
  },
  mutations: {
    setLanguage(state, value) {
      state.language.previous = state.language.current;
      state.language.current = value;
    },
    toggleTranslateBar(state, value) {
      state.translateBar.active = value;
    },
    toggleTranslateDropdown(state, value) {
      state.translateDropdown.active = value;
    },
    toggleLoading(state, value) {
      state.loading.active = value;
    },
    toggleTimeout(state, value) {
      state.timeout.active = value;
    },
    updateFilteredSchools(state, schools) {
      state.filteredSchools = schools
    },
    updateHomeschools(state, schools) {
      state.homeschools = schools
    },
    toggleMobileFilters(state, value) {
      state.showMobileFilters = value
    },
    updateTooltip(state, value) {
      state.tooltip.display = value.display
      state.tooltip.id = value.id
      state.tooltip.title = value.title
      state.tooltip.description = value.description
    },
    updateComparedSchools(state, data) {
      if (data.checked) {
        data.school.selected = true
        state.compare.schools[data.school.id] = data.school
        state.compare.keys.push(data.school.id)
      } else {
        data.school.selected = false
        delete state.compare.schools[data.school.id]
        let index = state.compare.keys.indexOf(data.school.id)
        state.compare.keys.splice(index, 1)
      }

      state.schools.forEach(school => {
        school.disabled = (state.compare.keys.length === 2 && state.compare.keys.indexOf(school.id) === -1) ? true : false
      })
    },
    updateComparedCategories(state, categories) {
      state.compare.categories = categories
    },
    toggleCompare(state, value) {
      state.compare.active = value
    },
    resetCompare(state) {
      for (let i = 0; i < state.schools.length; i++) {
        state.schools[i].disabled = false
        state.schools[i].selected = false
      }
      state.compare = {
        active: false,
        schools: {},
        categories: [],
        keys: []
      }
    }
  },
  actions: {

    toggleMoreModal({state, commit}, modal) {
      state.moreModal.school = modal.school
      state.moreModal.active = modal.active

      if (modal.active) {
        state.schools.forEach(school => { school.disabled = true }) // disable all schools to keep keyboard interaction on modal (accessibility)
        state.moreModal.returnElement = modal.returnElement
      } else {
        state.schools.forEach(school => {
          school.disabled = (state.compare.keys.length === 2 && !state.compare.keys.includes(school.id)) ? true : false // if school was disabled prior to more modal leave disabled
        })
        state.moreModal.returnElement.focus() // return focus to previously pressed button (accessibility)
      }

    },
    updateCompareObject({state, rootState, commit, dispatch}, data) {
      commit('updateComparedSchools', data)

      //need to rebuild category data so we don't alter state.search.categories, objects are passed by reference
      //this is so we only show features that schools actually have on compare page
      //could use a refactor, this isn't scalable
      let categoryIDs = []
      let featureIDs = []

      for (let s in state.compare.schools) {
        state.compare.schools[s].categories.forEach((c) => {
          if (!categoryIDs.includes(c.id)) {
            categoryIDs.push(c.id)
          }
          c.features.forEach(f => {
            if (!featureIDs.includes(f.id)) {
              featureIDs.push(f.id)
            }
          })
        })
      }

      let categories = []
      rootState.search.categories.forEach((c) => {
        if (categoryIDs.includes(c.id)) {
          categories.push({
            id: c.id,
            name: c.name,
            features: []
          })
          c.features.forEach((f) => {
            if (featureIDs.includes(f.id)) {
              for (let i = 0; i < categories.length; i++) {
                if (categories[i].id === f.category_id) {
                  categories[i].features.push({
                    id: f.id,
                    name: f.name
                  })
                }
              }
            }
          })
        }
      })

      commit('updateComparedCategories', categories)

      // maybe this will be a better way to run this function in the future
      // state.compare.keys.forEach(key => {
      //   let copy = JSON.parse(JSON.stringify(state.compare.schools[key].categories))
      // })

    },
    reset({state, commit}) {
      commit('toggleResultsTag', false)
      commit('resetCompare')

      commit('updateFilteredSchools', { normal: shuffle(state.schools), choice: [], results: state.schools.length })
      commit('updateHomeschools', [])

      commit('updateGeocodedResults', {active: false, latLng: {}, address: ''})

      commit('updateGradeLevel', '')
      commit('resetFeatures')
    }
  }
}
